module.exports = __webpack_public_path__ + "resources/img/career-welfareImg6.9ccc0385.jpg";